
import request from '@/utils/request'

// 配置项列表
export function getExportSheet(tagCode) {
  return request({
    url: `/api/manage/data/export/${tagCode}`,
    method: 'get',
  })
}

export default {
  getExportSheet
}
